/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useLocation } from "react"
import PropTypes from "prop-types"
import Helmet from 'react-helmet'

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const Layout = ({ children, contact }) => {

    if (typeof window !== 'undefined') {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault()
                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                })
            })
        })
    }

    return (
        <>
            <Helmet>
                <body className="font-inter text-black scroll-smooth" />
            </Helmet>
            <Header />
            <div>
                <main>{children}</main>
                <Footer contact={contact} bgClass="bg-rekord-lorange" />
            </div>
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
